export default "__VITE_ASSET__CpukG2m2__"